<ng-container *transloco="let t">
  @switch (state()) {
    @case (ActionStatus.WAITING) {
      <tui-icon
        class="text-text-brand-secondary cursor-default"
        data-testid="status-pending-icon"
        icon="@tui.dot"
        tuiHintDirection="end"
        [tuiHint]="t('Modifications non enregistrées')" />
    }
    @case (ActionStatus.IN_PROGRESS) {
      <tui-icon
        class="text-text-primary animate-spin cursor-default"
        data-testid="status-ongoing-icon"
        icon="@tui.loader-circle"
        tuiHintDirection="end"
        [tuiHint]="t('Enregistrement en cours…')" />
    }
    @case (ActionStatus.ERROR) {
      <pxc-error-icon data-testid="status-error-icon" [message]="errorMessage()" />
      @if (exportData()) {
        <button
          appearance="flat"
          data-testid="status-download-button"
          size="xs"
          tuiHintDirection="end"
          tuiIconButton
          type="button"
          [tuiHint]="t('Télécharger les données pour le support Pixacare')"
          (click)="downloadExportData()">
          <tui-icon icon="@tui.download" />
        </button>
      }
    }
  }
</ng-container>
